import { Model, Phase } from "@gaming/srvg-classes-core";

export const PHASE_MODEL_PHASE = 'phase';

export class PhaseModel extends Model {
    phase: Phase;

    constructor() {
        super();
        this.phase = null;
    }

    setPhase( phase: Phase ) {
        this.setProperty( PHASE_MODEL_PHASE, phase );
    }

    destroy() {
        this.phase = null;
        super.destroy();
    }
}